<template>
  <div class="who-owes-me-widget-container">
    <div v-if="loading" class="who-owes-me-widget-loading">Loading...</div>
    <div v-else-if="error" class="who-owes-me-widget-error">{{ error }}</div>
    <table v-else class="who-owes-me-widget-table">
      <thead>
        <tr>
          <th>Customer</th>
          <th class="who-owes-me-widget-amount-header">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="customers.length === 0">
          <td colspan="2" class="who-owes-me-widget-empty">No outstanding invoices</td>
        </tr>
        <tr v-else v-for="customer in customers" :key="customer.id">
          <td>{{ customer.customerName || customer.name }}</td>
          <td class="who-owes-me-widget-amount-cell">{{ formatCurrency(customer.balance) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="customers.length > 0" class="who-owes-me-widget-footer">
      <router-link :to="`/company/${companyId}/dashboard/customers/invoices`" class="who-owes-me-widget-link">View all invoices →</router-link>
    </div>
  </div>
</template>

<script>
import './styles/WhoOwesMeWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'WhoOwesMeWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      customers: [],
      loading: true,
      error: null
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const invoices = await ApiService.getAllCustomerInvoices(this.companyId);
        const invoicesArray = Array.isArray(invoices) ? invoices : [];
        
        // Group by customer and sum balances
        const customerMap = new Map();
        invoicesArray.forEach(invoice => {
          if (invoice.status === 'voided' || invoice.status === 'cancelled' || !invoice.balanceAmount || invoice.balanceAmount <= 0) return;
          
          const customerId = invoice.customerId;
          const customerName = invoice.customerName || invoice.customer?.customerName || 'Unknown Customer';
          
          if (!customerMap.has(customerId)) {
            customerMap.set(customerId, {
              id: customerId,
              customerName: customerName,
              balance: 0
            });
          }
          
          const customer = customerMap.get(customerId);
          customer.balance += parseFloat(invoice.balanceAmount || 0);
        });
        
        this.customers = Array.from(customerMap.values())
          .sort((a, b) => b.balance - a.balance)
          .slice(0, 10); // Top 10
      } catch (error) {
        logger.error('Error fetching who owes me data:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

